/**
 * simple index页面
 */
export default {
  shopCountCard: {
    title: '商城指数计算数量',
    help: '指数计算包含商城数量',
    haveTotalLabel: '账号下已有商城',
    noTotalLabel: '账号下未有商城',
  },
  shopScatterCard: {
    title: '商城指数分布图',
    help: '指数计算包含商城数量',
    haveOpt: '账号商城opt-p数量',
    notOpt: '未配置商城opt-p数量',
    haveRet: '账号商城ret-p数量',
    notRet: '未配置商城ret-p数量',
  },
  shopListCard: {
    title: '商城指数',
    help: '所有商城指数',
    searchForm: {
      LabelText: '商城名称',
      submitText: '提交',
    },
    tableColumns: {
      shopName: '商城名称',
      opt: '指数（折扣价）',
      ret: '指数（原价）',
      all: '全部',
      have: '已拥有',
      no: '未拥有',
    },
  },
  shopLineCard: {
    title: '商城指数折线图',
    help: '查看账号下商城和商品历史指数, X: 时间 Y:指数',
    export: '导出',
    searchForm: {
      screen: '筛选',
      type: '类型',
      curr: '单位',
      time: '时间',
      submit: '提交',
      pleaseInput: '请输入',
      typeOption: {
        retail: '原价',
        optimal: '折扣价',
      },
      rule: {
        shopNum: '请选择商城',
        makeDate: '请选择时间范围',
      },
    },
    shopDetailDialog: {
      title: '筛选',
      title_: '详情',
      brand: '品牌',
      category: '分类',
      export: '导出',
      brandTable: {
        brand: '品牌',
        index: '指数',
        detail: '详情',
        view: '查看',
      },
      categoryTable: {
        category: '分类',
        index: '指数',
        detail: '详情',
        view: '查看',
      },
    },
    productDetailDialog: {
      title: '商品详情',
      category: '分类',
      priceType: '价格类型',
      curr: '货币',
      btn: '关闭',
      tableColumns: {
        code: 'CODE',
        description: '描述',
        image: '图片',
        index: '指数',
        price: '价格',
      },
    },
  },
};
